export * from './TrainingSoftSkillsAdmin';
